import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';
import type { IconSummary } from 'shared/src/api';

export const useLogClickIcon = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    (icon: IconSummary) => {
      logAnalyticsEvent({
        name: 'CLICK_OVERVIEW_ICON',
        analytics: icon.logging.analytics,
      });
    },
    [logAnalyticsEvent],
  );
};
